import { useCurrentSessionId } from '@heidi/runtime/shell';

import { useQuerySessionById } from './useQuerySessionById';

export function useCurrentSessionIsTabSharing() {
  return useSessionIsTabSharing({ sessionId: useCurrentSessionId() });
}

export function useSessionIsTabSharing({ sessionId }: { sessionId: string }) {
  const { data: session } = useQuerySessionById({
    sessionId,
    select: (data) => {
      if (!data) return undefined;
      return {
        is_tab_sharing: data.is_tab_sharing,
      };
    },
  });

  return session?.is_tab_sharing ?? false;
}
